import { ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { TranslationService, I18nModule } from '@spartacus/core';
import { ToastrService } from 'ngx-toastr';
import { pairwise } from 'rxjs/operators';
import { CustomProductsService } from '../custom-products.service';
import { NgIf, NgFor, KeyValuePipe } from '@angular/common';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { CustomProductCarouselComponent } from '../custom-product-carousel/custom-product-carousel.component';
import { ProductsListViewComponent } from '../products-list-view/products-list-view.component';
@Component({
    selector: 'app-custom-product-type-content',
    templateUrl: './custom-product-type-content.component.html',
    styleUrls: ['./custom-product-type-content.component.scss'],
    imports: [NgIf, InfiniteScrollDirective, NgFor, CustomProductCarouselComponent, ProductsListViewComponent, KeyValuePipe, I18nModule]
})
export class CustomProductTypeContentComponent implements OnInit, OnChanges {
  browseType = 'productType';
  productData: any;
  @Input() list: any;
  @Input() grid: any;
  @Input() sortData: any;
  data: any;
  showNotAvailableMsg = false;
  enableLoader = true;
  currentPage = 0;
  pageSize = 2;
  reachedToEnd = false;
  notScrolly = true;
  nextProducts: any;
  page = 0;
  filterUrl = null;
  loaderShow = false;
  error: string;
  allProductsData: any;
  constructor(private customProductService: CustomProductsService,
              private cd: ChangeDetectorRef,
              private toastService: ToastrService,
              private translation: TranslationService) { }

  ngOnChanges(): any {
  }

  ngOnInit(): void {

    this.customProductService.filterInput$.pipe(pairwise()).subscribe(([previous, current]) => {
      if (previous !== current) {
      this.cd.detectChanges();
      this.reachedToEnd = false;
      this.currentPage = 0;
      this.pageSize = 2;
      this.page = 0;
      this.filterUrl = current;
      if (this.filterUrl != null){
        this.products(0 , this.pageSize, 'relevance' , current);
      }else{
        this.products(0, this.pageSize, this.sortData);
      }
    }
    });

    this.customProductService.refreshCompProduct$.subscribe(result => {
      if (result != null) {
        this.enableLoader = true;
        this.products(this.currentPage, this.pageSize, this.sortData, this.customProductService.filterValue);
      }
    });

    this.products(this.currentPage, this.pageSize, this.sortData);
    this.customProductService.languageChange$.subscribe(([previous, current]) => {
      if (previous !== current) {
      if (current != null) {
        this.enableLoader = true;
        this.products(this.currentPage, this.pageSize, this.sortData, this.customProductService.filterValue);
      }
    }
    });

    this.customProductService.searchInput$.pipe(pairwise()).subscribe(([previous, current]) => {
      if (previous !== current) {
      this.cd.detectChanges();
      this.reachedToEnd = false;
      this.currentPage = 0;
      this.page = 0;
      this.products(this.currentPage, this.pageSize, 'relevance' , current);
      }
    });
    this.translation.translate('home.toastErrorMessages.product').subscribe(res => {

      this.error = res;

    });

  }

  products(currentPage?, pageSize?, sort? , searchInput?): any {
    this.customProductService.getProducts(currentPage, pageSize, sort , searchInput).subscribe(data => {
      // this.productData = data;
      // this.allProductsData = data;
      const filterProductByPort = [];
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0 ; i < data.products.length; i++){
        if (data.products[i].ports.length > 0){
          filterProductByPort.push(data.products[i]);
        }
      }
      this.allProductsData = filterProductByPort;
      this.productData = filterProductByPort.reduce(function (r, a) {
        r[a.baseProductCode] = r[a.baseProductCode] || [];
        r[a.baseProductCode].push(a);
        return r;
    }, Object.create(null));
      this.showNotAvailableMsg = false;
      this.enableLoader = false;
      // this.productData = this.sampleData;
      if (data.products.length === 0) {
        this.showNotAvailableMsg = true;
      }

    }, err => {
      this.toastService.show(this.error);
      this.enableLoader = false;
    });
  }


  onScroll(): any {
    if (!this.reachedToEnd){
    this.loaderShow = true;
    setTimeout(() => {
      this.loadNextDataProducts();
    }, 1000);
      }

  }

  onScrollGrid(): any {

    if (!this.reachedToEnd){
    this.loaderShow = true;
    setTimeout(() => {
      this.loadNextDataProductsGrid();
    }, 1000);
    }


  }

  loadNextDataProducts(): any {
    this.currentPage += 1;
    if (!this.reachedToEnd){
    this.customProductService.getProducts(this.currentPage, this.pageSize, this.sortData, this.customProductService.filterValue)
      .subscribe(data => {
        this.loaderShow = false;
       // this.nextProducts = data;
        if (this.nextProducts.pagination.totalResults === 0) {
          this.reachedToEnd = true;
        }
        const filterProductByPort = [];
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0 ; i < data.products.length; i++){
          if (data.products[i].ports.length > 0){
            filterProductByPort.push(data.products[i]);
          }
        }
        this.nextProducts = filterProductByPort;
        this.allProductsData = this.allProductsData.concat(this.nextProducts);
        this.productData = this.allProductsData.reduce(function (r, a) {
          r[a.baseProductCode] = r[a.baseProductCode] || [];
          r[a.baseProductCode].push(a);
          return r;
      }, Object.create(null));
       // this.productData.products = this.productData.products.concat(this.nextProducts.products);

      });
    }else{
      this.loaderShow = false;
    }
    // this.productData.products = this.productData.products.concat(this.nextProducts.products);
  }

  loadNextDataProductsGrid(): any {
    this.page += 1;
    if (!this.reachedToEnd){
      this.customProductService.getProducts(this.page, this.pageSize, this.sortData, this.customProductService.filterValue)
      .subscribe(data => {
        this.loaderShow = false;
       // this.nextProducts = data;
        if (data.pagination.totalResults === 0) {
          this.reachedToEnd = true;
        }
        const filterProductByPort = [];
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0 ; i < data.products.length; i++){
          if (data.products[i].ports.length > 0){
            filterProductByPort.push(data.products[i]);
          }
        }
        this.nextProducts = filterProductByPort;
        this.allProductsData = this.allProductsData.concat(this.nextProducts);
        this.productData = this.allProductsData.reduce(function (r, a) {
          r[a.baseProductCode] = r[a.baseProductCode] || [];
          r[a.baseProductCode].push(a);
          return r;
      }, Object.create(null));
        //this.productData.products = this.productData.products.concat(this.nextProducts.products);
      });
    }else{
      this.loaderShow = false;
    }
  }
}
